import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaTrash, FaEdit, FaArrowUp, FaArrowDown } from "react-icons/fa";
import LayerExport from "./LayerExport";
import LasLayerControls from "./lasControls/LasLayerControls";
import "./LayersPanel.css";

const LayerGroupsManager = ({
    groups,
    setGroups,
    layers,
    setLayers,
    toggleVisibility,
    changeOpacity,
    deleteLayer,
    moveLayer,
    removeLayerFromGroups,
    wfsLayers,
    wmsLayers,
    lasLayers,
    setLasLayers
}) => {
    const [newGroupName, setNewGroupName] = useState("");

    const createGroup = () => {
        const trimmed = newGroupName.trim();
        if (!trimmed || groups.find(g => g.name === trimmed)) return;
        setGroups([...groups, { name: trimmed, visible: true, layerIds: [] }]);
        setNewGroupName("");
    };

    const toggleGroupVisibility = (groupName) => {
        const updatedGroups = groups.map(g =>
            g.name === groupName ? { ...g, visible: !g.visible } : g
        );
        setGroups(updatedGroups);

        const visible = !groups.find(g => g.name === groupName)?.visible;
        const updatedLayers = layers.map(layer =>
            groups.find(g => g.name === groupName)?.layerIds.includes(layer.id)
                ? layer.clone({ visible })
                : layer
        );
        setLayers(updatedLayers);
    };

    const renameGroup = (oldName, newName) => {
        const updatedGroups = groups.map(g =>
            g.name === oldName ? { ...g, name: newName } : g
        );
        setGroups(updatedGroups);
    };

    const deleteGroup = (groupName) => {
        setGroups(groups.filter(g => g.name !== groupName));
        const updatedLayers = layers.map(layer =>
            groups.find(g => g.name === groupName)?.layerIds.includes(layer.id)
                ? { ...layer, group: null }
                : layer
        );
        setLayers(updatedLayers);
    };

    const getLayersInGroup = (groupName) => {
        const group = groups.find(g => g.name === groupName);
        return group ? layers.filter(layer => group.layerIds.includes(layer.id)) : [];
    };

    const getLayerType = (layer) => {
        const id = layer.id?.toLowerCase() || "";
        if (wmsLayers.some(l => l.id === layer.id)) return "wms";
        if (lasLayers.some(l => l.id === layer.id)) return "las";
        if (id.startsWith("kml")) return "kml";
        if (id.startsWith("gml")) return "gml";
        if (id.startsWith("geojson")) return "geojson";
        if (id.startsWith("pgsql")) return "pgsql";
        if (id.startsWith("dx")) return "dxf";
        return "wfs";
    };

    const parseLayerName = (id) => {
        const parts = id.split("-");
        return parts.length > 1 ? parts.slice(1).join("-") : id;
    };

    const formatLayerTitle = (layer) => {
        const type = getLayerType(layer);
        return `[${type}] ${parseLayerName(layer.id)}`;
    };

    return (
        <div style={{ marginBottom: "12px" }}>
            <h6 style={{ fontWeight: 'bold' }}>Grupe slojeva</h6>

            <div style={{ display: 'flex', gap: '6px', marginBottom: '8px' }}>
                <input
                    type="text"
                    value={newGroupName}
                    onChange={(e) => setNewGroupName(e.target.value)}
                    placeholder="Naziv nove grupe"
                    style={{ flex: 1, padding: '4px' }}
                />
                <button onClick={createGroup} className="addedLayer-panel-button">Kreiraj</button>
            </div>

            <Accordion alwaysOpen>
                {groups.map(group => (
                    <Accordion.Item eventKey={group.name} key={group.name}>
                        <Accordion.Header>{group.name}</Accordion.Header>
                        <Accordion.Body>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                                <span>Preimenuj:</span>
                                <button
                                    onClick={() => {
                                        const newName = prompt("Novi naziv grupe:", group.name);
                                        if (newName && newName !== group.name) renameGroup(group.name, newName);
                                    }}
                                    style={{ background: "none", border: "none", color: "#fff", cursor: "pointer" }}
                                    title="Preimenuj grupu"
                                >
                                    <FaEdit />
                                </button>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                                <span>Vidljivost:</span>
                                <button
                                    onClick={() => toggleGroupVisibility(group.name)}
                                    style={{ background: "none", border: "none", color: "#fff", cursor: "pointer" }}
                                    title="Vidljivost grupe"
                                >
                                    {group.visible ? <FaEye /> : <FaEyeSlash />}
                                </button>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                                <span>Obriši:</span>
                                <button
                                    onClick={() => deleteGroup(group.name)}
                                    style={{ background: "none", border: "none", color: "#fff", cursor: "pointer" }}
                                    title="Obriši grupu"
                                >
                                    <FaTrash />
                                </button>
                            </div>

                            <Accordion alwaysOpen>
                                {(() => {
                                    const groupedLayers = getLayersInGroup(group.name);
                                    return groupedLayers.map((layer, index) => {
                                        const type = getLayerType(layer);
                                        const isWms = type === "wms";

                                        const sameTypeLayers = groupedLayers.filter(l => getLayerType(l) === type);
                                        const typeIndex = sameTypeLayers.findIndex(l => l.id === layer.id);
                                        const isFirst = typeIndex === 0;
                                        const isLast = typeIndex === sameTypeLayers.length - 1;

                                        return (
                                            <Accordion.Item eventKey={`${group.name}-${index}`} key={layer.id}>
                                                <Accordion.Header>{formatLayerTitle(layer)}</Accordion.Header>
                                                <Accordion.Body>
                                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                                        <span>Redoslijed:</span>
                                                        <div style={{ display: "flex", gap: "8px" }}>
                                                            <button
                                                                onClick={() => moveLayer(typeIndex, -1, type)}
                                                                disabled={isFirst}
                                                                title="Pomjeri sloj gore"
                                                                style={{ background: "none", border: "none", cursor: "pointer", color: isFirst ? "#777" : "#fff" }}
                                                            >
                                                                <FaArrowUp />
                                                            </button>
                                                            <button
                                                                onClick={() => moveLayer(typeIndex, 1, type)}
                                                                disabled={isLast}
                                                                title="Pomjeri sloj dole"
                                                                style={{ background: "none", border: "none", cursor: "pointer", color: isLast ? "#777" : "#fff" }}
                                                            >
                                                                <FaArrowDown />
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <span>Vidljivost:</span>
                                                        <button
                                                            onClick={() => toggleVisibility(layer, typeIndex, type, isWms)}
                                                            style={{ border: "none", background: "none", color: "#fff" }}
                                                            title={layer.props.visible ? "Sakrij sloj" : "Prikaži sloj"}
                                                        >
                                                            {layer.props.visible ? <FaEye /> : <FaEyeSlash />}
                                                        </button>
                                                    </div>

                                                    {type === "wfs" && <LayerExport layer={layer} />}

                                                    {type !== "las" && (
                                                        <div style={{ marginTop: "8px" }}>
                                                            <label style={{ display: "block", marginBottom: "4px" }}>
                                                                Prozirnost: {parseFloat(layer.props.opacity ?? 1).toFixed(1) * 100}%
                                                            </label>
                                                            <input
                                                                type="range"
                                                                min="0"
                                                                max="1"
                                                                step="0.01"
                                                                value={layer.props.opacity ?? 1}
                                                                onChange={(e) => changeOpacity(layer, e.target.value, typeIndex, type, isWms)}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "6px",
                                                                    borderRadius: "4px",
                                                                    background: `linear-gradient(to right, #007bff 0%, #007bff ${(layer.props.opacity ?? 1) * 100}%, #e0e0e0 ${(layer.props.opacity ?? 1) * 100}%, #e0e0e0 100%)`,
                                                                    appearance: "none",
                                                                    outline: "none",
                                                                }}
                                                            />
                                                        </div>
                                                    )}

                                                    {type === "las" && (
                                                        <LasLayerControls
                                                            layer={layer}
                                                            index={typeIndex}
                                                            lasLayers={lasLayers}
                                                            setLasLayers={(newLas) => {
                                                                const others = layers.filter(l => !l.id?.startsWith("las"));
                                                                setLayers([...others, ...newLas]);
                                                                setLasLayers(newLas);
                                                            }}
                                                        />
                                                    )}

                                                    <div style={{ marginTop: '10px' }}>
                                                        <button
                                                            onClick={() => deleteLayer(layer, typeIndex, type, isWms)}
                                                            style={{
                                                                width: '100%',
                                                                backgroundColor: '#dc3545',
                                                                color: 'white',
                                                                border: 'none',
                                                                padding: '6px 12px',
                                                                borderRadius: '4px',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            Obriši sloj
                                                        </button>
                                                    </div>

                                                    <div style={{ marginTop: '8px' }}>
                                                        <button
                                                            onClick={() => removeLayerFromGroups(layer.id)}
                                                            style={{
                                                                backgroundColor: "#ffc107",
                                                                color: "#fff",
                                                                border: "none",
                                                                padding: "4px 8px",
                                                                borderRadius: "4px",
                                                                cursor: "pointer",
                                                                width: "100%"
                                                            }}
                                                            title="Ukloni sloj iz grupe"
                                                        >
                                                            Izađi iz grupe
                                                        </button>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        );
                                    });
                                })()}
                            </Accordion>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </div>
    );
};

export default LayerGroupsManager;
